import React from 'react';
import PropTypes from 'prop-types';

import { RemoveButton } from './Buttons';

const SpeakerDetail = ({
  fields,
  speaker,
  removeSpeaker,
  updateSpeaker,
  isValidSpeakerValue,
  onDrop
}) => (
  <div>
    <div className="is-divider custom-divider" data-content="Speaker detail" />
    {fields.speakers.length > 1 && <RemoveButton id={speaker.id} removeSpeaker={removeSpeaker} />}
    <div className="form-group columns">
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' has-error'
        }`}
        htmlFor="speakerName">
        {speaker.speakerName.label}
      </label>
      <div className="column fix-space-sm">
        <input
          className={`form-control input is-rounded ${
            isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' is-danger'
          }`}
          name="speakerName"
          onChange={e => updateSpeaker(speaker.id, e)}
          placeholder="Speaker's Name"
          type="text"
          value={speaker.speakerName.value}
        />
      </div>
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'email') ? '' : ' has-error'
        }`}
        htmlFor="email">
        {speaker.email.label}
      </label>
      <div className="column">
        <input
          className={`form-control input is-rounded ${
            isValidSpeakerValue(speaker.id, 'email') ? '' : ' is-danger'
          }`}
          name="email"
          onChange={e => updateSpeaker(speaker.id, e)}
          placeholder="Email Address"
          type="email"
          value={speaker.email.value}
        />
      </div>
    </div>
    <div className="form-group columns">
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'company') ? '' : ' has-error'
        }`}
        htmlFor="company">
        {speaker.company.label}
      </label>
      <div className="column fix-space-sm">
        <input
          className={`form-control input is-rounded ${
            isValidSpeakerValue(speaker.id, 'company') ? '' : ' is-danger'
          }`}
          name="company"
          onChange={e => updateSpeaker(speaker.id, e)}
          placeholder="Company"
          type="text"
          value={speaker.company.value}
        />
      </div>
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'country') ? '' : ' has-error'
        }`}
        htmlFor="country">
        {speaker.country.label}
      </label>
      <div className="column">
        <input
          className={`form-control input is-rounded ${
            isValidSpeakerValue(speaker.id, 'country') ? '' : ' is-danger'
          }`}
          name="country"
          onChange={e => updateSpeaker(speaker.id, e)}
          placeholder="Country"
          type="text"
          value={speaker.country.value}
        />
      </div>
    </div>
    <div className="form-group columns ">
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' has-error'
        }`}
        htmlFor="speakerBio">
        {speaker.speakerBio.label}
      </label>
      <div className="column">
        <textarea
          className={`form-control textarea ${
            isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' is-danger'
          }`}
          name="speakerBio"
          onChange={e => updateSpeaker(speaker.id, e)}
          placeholder="About Speaker"
          rows="2"
          type="text"
          value={speaker.speakerBio.value}
        />
      </div>
    </div>
    <div className="form-group columns ">
      <label
        className={`control column is-2 label ${
          isValidSpeakerValue(speaker.id, 'photo') ? '' : ' has-error'
        }`}
        htmlFor="photo">
        {speaker.photo.label}
      </label>
      <div className="column">
        {!speaker.photo.value ? (
          <div>
            <span
              className={`upload-rules ${
                isValidSpeakerValue(speaker.id, 'photo') ? '' : ' has-error'
              }`}>
              Square dimensions i.e. 200x200, max size 1 MB, allowed types: .jpg, .jpeg, .png
            </span>
            <input
              accept=".jpg, .jpeg, .png"
              className={`form-control input is-rounded ${
                isValidSpeakerValue(speaker.id, 'photo') ? '' : ' is-danger'
              }`}
              name="photo"
              onChange={e => onDrop(speaker.id, e.target.files)}
              type="file"
            />
            <span className="photo-error">{speaker.photo.error}</span>
          </div>
        ) : (
          <div className="speaker-imge-row">
            <img alt="" src={speaker.photo.value} />
            <button
              className="delete is-large remove-button"
              onClick={() => updateSpeaker(speaker.id, '', '')}
              type="button">
              Remove
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
);

SpeakerDetail.propTypes = {
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
  isValidSpeakerValue: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  removeSpeaker: PropTypes.func.isRequired,
  speaker: PropTypes.objectOf(PropTypes.any).isRequired,
  updateSpeaker: PropTypes.func.isRequired
};

export default SpeakerDetail;
